module.exports = __webpack_public_path__ + "static/media/google_ads.35616120.png";